"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBFooter", {
  enumerable: true,
  get: function get() {
    return _SVBFooter.default;
  }
});
var _SVBFooter = _interopRequireDefault(require("./src/SVBFooter"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }